export enum OriginUrl {
    G100_01 = 'G100_01',
    G100_02 = 'G100_02',
    G100_03 = 'G100_03',
    LAIF = 'LAIF',
}
